import header from '../views/common/header';
import gnb from '../views/common/gnb';

export default [
  {
    path: '/views/overview/whole',
    meta: { hiddenGroupSelector: true },
    components: {
      default: () => import('../views/overview/whole'),
      header,
      gnb,
    },
  },
  {
    path: '/views/overview/system',
    meta: { stackType: 'ALL' },
    components: {
      default: () => import('../views/overview/system'),
      header,
      gnb,
    },
  },
  {
    path: '/views/overview/system/:systemId',
    meta: { stackType: 'ALL' },
    components: {
      default: () => import('../views/overview/system'),
      header,
      gnb,
    },
  },
  // BEGIN::Added.by.KWShin.2023.12.06.
  {
    path: '/views/overview/workprcs',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/overview/workprcs'),
      header,
      gnb,
    },
  },
  {
    path: '/views/overview/workprcs/:systemId',
    meta: { stackType: 'ABAP' },
    components: {
      default: () => import('../views/overview/workprcs'),
      header,
      gnb,
    },
  },
  // FINISH::Added.by.KWShin.2023.12.06.
];
